import axios from 'axios';

const uploadIssuePhoto = (file) => {
  const formData = new FormData();
  formData.append('photo', file);
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/issue/uploadIssuePhoto`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(res => res)
    .catch(err => err);
};

export default uploadIssuePhoto;
